import TerciaryButton from "@/components/buttons/terciary-button/TerciaryButton";
import type { OrderItem } from "@/types/types.d";
import { getMetaDetailData, getPhotoData } from "../../utils/photo-data";
import { literals } from "@/constants/literals";
import Image from "../../components/Image";
import { Icon } from "@/components/icons/Icon";

const PhotosDetailMobile = ({
  photo,
  cleanPhoto,
}: {
  photo: OrderItem;
  cleanPhoto: () => void;
}) => {
  const photoName = photo.imageKey.split("/").slice(-1)[0];
  const metaData = getMetaDetailData(photo);
  const fullData = getPhotoData(photo);

  return (
    <div data-testid="photo-detail-mobile" className="relative">
      <div className="bg-[#EEEEEE] -mx-4 -mt-4 flex fixed w-full">
        <div>
          <TerciaryButton
            onClick={cleanPhoto}
            icon="arrowLeft"
            size="small"
            dataTestid="go-back-photo-mobile"
            label={literals.goBackList}
            colour={"red"}
          />
        </div>
      </div>
      <div className="grid gap-2 py-8">
        {photo.hasDeletionRequest && (
          <div
            className="border border-[#FCD100] bg-[#FFFAE0] text-[#464646] font-ib-bold p-2 mb-4 rounded-sm flex gap-2 w-full"
            data-testid="deletion-request-warning"
          >
            <Icon name="warningTriangle" className="text-[#C7A400]" />
            <p>{literals.hasRequestDeletion}</p>
          </div>
        )}
        {photo.requestType === "EDIT" && (
          <div
            className="border border-[#FCD100] bg-[#FFFAE0] text-[#464646] font-ib-bold p-2 mb-4 rounded-sm flex gap-2 w-full"
            data-testid="deletion-request-warning"
          >
            <Icon name="warningTriangle" className="text-[#C7A400]" />
            <p>{literals.hasRequestEdition}</p>
          </div>
        )}
        <h1 className="text-xl">{photoName}</h1>
        <Image imageId={photo.imageId} />
        <div className=" grid gap-4 ">
          <div className="grid gap-x-2 gap-y-4 grid-cols-3">
            {metaData.map((data) => (
              <BlockInfo
                key={data.label}
                label={data.label}
                value={data.value}
              />
            ))}
          </div>
          <BlockInfo
            key={"description"}
            label={literals.description}
            value={photo.description || "-"}
          />
          <div className="grid gap-x-2 gap-y-4 grid-cols-2">
            {fullData
              .filter((_, index) => index < 3)
              .map((data) => (
                <BlockInfo
                  key={data.label}
                  label={data.label}
                  value={data.value}
                />
              ))}
          </div>
          <div className="grid gap-x-2 gap-y-4 grid-cols-2">
            {fullData
              .filter((_, index) => index > 2)
              .map((data) => (
                <BlockInfo
                  key={data.label}
                  label={data.label}
                  value={data.value}
                />
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhotosDetailMobile;

const BlockInfo = ({ label, value }: { label: string; value: string }) => {
  return (
    <div
      data-testid={`block-info-${label}`}
      className="flex flex-col text-sm gap-1"
    >
      <p className="text-[#666666]">{label}</p>
      <p className="text-[#333333] font-ib-bold">{value}</p>
    </div>
  );
};
